module.exports = __webpack_public_path__ + "static/media/Modenatur-LogoBlu.aeedb58a.png";